const FARO_EVENT = {
    PostMessageError: "sso-post-message-error",
    PostMessageSent: "sso-post-message-sent",
    SilentAuthPostMessageError: "sso-silent-auth-post-message-error",
    SilentAuthPostMessageSent: "sso-silent-auth-post-message-sent",
    PageDiscarded: "sso-page-was-discarded",
    WindowOpenerError: "sso-window-opener-error",
    WindowOpenerCapturedFromSdkPing: "sso-window-opener-provider",
    FormValidationFailed: "sso-form-validation-failed",
    InlineSignInPostMessageSent: "sso-post-message-inline-sign-in",
    InlineSignInMetadataRetrieved: "sso-inline-sign-in-metadata-retrieved",
    InlineSignInMetadataError: "sso-inline-sign-in-metadata-error",
    GmailLinkToOtpEmailClicked: "sso-gmail-link-to-otp-email-clicked",
};
export const FARO_INIT_ATTRIBUTE = {
    SessionId: "sessionId",
    TraceId: "traceId",
    ClientId: "clientId",
    AccountId: "accountId",
    Environment: "environment",
    AsyncInit: "asyncInit",
};
